export const ECO_QUESTIONS = [
  {
    fieldname: 'architectureEcoQuestions1',
    question:
      'Which design decisions were made to prioritize lower energy consumption and reduced resource use during daily operations?',
    answers: [
      'Ongoing social and/or environmental measurement and monitoring',
      'Planned obsolescence incl. disassembly and material reuse and recycling',
      'Flexible and adaptable spaces that can be easily retrofitted or modified for future changes',
      'Renewable energy systems (e.g., solar panels, wind turbines, geothermal, etc.)',
      'Water-saving fixtures and systems (e.g., low-flow faucets, dual-flush toilets, etc.)',
      'Other',
      'Energy-efficient lighting systems (e.g., LED fixtures, automated sensors, etc.)',
      'Not sure / Not applicable',
      'Materials with low environmental impact (e.g., recycled, locally sourced, etc.)',
      'Passive design strategies (e.g., natural ventilation, daylighting, etc.)',
    ],
  },
  {
    fieldname: 'architectureEcoQuestions2',
    question:
      'In what ways does your design support and promote human health and well-being from construction through end of life?',
    answers: [
      'Execute clear waste management strategies in construction (e.g., recycling, salvage, hazardous waste, etc.)',
      'Ensure healthy air circulation, filtration, and light',
      'Prioritize construction worker safety (e.g., protective equipment, training, rest areas, etc.)',
      'Use of non-toxic materials (low VOC)',
      'Use of low-embodied carbon materials',
      'Use of highly durable materials with low environmental impact',
      'Use materials from fair labor sources',
      'Build personal wellness options into the design',
      'Flexible spaces for multi-use',
      'Pay construction workers a livable wage',
      'Other',
      'Not sure / Not applicable',
    ],
  },
  {
    fieldname: 'architectureEcoQuestions3',
    question: 'How do you ensure equal access for all users?',
    answers: [
      'Use contrasting colors and textures to aid individuals with visual impairments',
      'Implement clear wayfinding',
      'Implement universal design principles',
      'Incorporate adaptive equipment and features',
      'Not sure / Not applicable',
      'Create clear pathways and circulation routes for wheelchair accessibility',
      'Install proper lighting to enhance visibility and safety',
      'Consider diverse sensory needs, such as noise levels and tactile experience',
      'Provide gender- and culturally-sensitive private areas',
      'Engage the community and account for broader inclusion in all public or shared spaces',
      'Other',
    ],
  },
  {
    fieldname: 'communicationEcoQuestion1',
    question:
      'Which design decisions were taken to prioritize environmental sustainability?',
    answers: [
      'Implement energy-efficient coding practices and website/digital optimization techniques',
      'Use greenest materials and techniques available for any physical asset production (e.g., recycled paper content/paper from responsibly-managed forests/tree-free paper alternatives, upcycled or reclaimed materials, water-based coatings and finishes, soy-or vegetable-based inks, etc.)',
      'Choose formats and distribution channels with a lower environmental impact whenever possible (e.g., reduce/remove physical outputs for lower energy/material footprint)',
      'Other',
      'Design for reuse, repurpose, or recyclability (e.g., multi-use installations, modular signage, etc.)',
      'Minimize data transfer and server load by optimizing file sizes and formats',
      'Select energy- and waste-optimized fonts',
      'Host digital assets on servers powered by renewable energy sources (e.g., solar, wind, etc.)',
      'Integrate language and storytelling that raises awareness of sustainability and/or encourages other positive behaviours',
      'Opt for remote collaboration vs. in-person travel whenever possible',
      'Not sure / Not applicable',
    ],
  },
  {
    fieldname: 'communicationEcoQuestion2',
    question:
      'How did you design this entry to be inclusive of diverse audiences (e.g., gender, ethnicity, disability, age, etc.)?',
    answers: [
      'Include stakeholders of diverse backgrounds in the design process (e.g., focus groups, creative talent, etc.)',
      'Represent people of diverse backgrounds in visuals, including casting',
      'Ensure no misleading content or disinformation is included',
      'Reduce text length and complexity',
      'Use inclusive language',
      'Present in different languages',
      'Other',
      'Not sure / Not applicable',
    ],
  },
  {
    fieldname: 'communicationEcoQuestion3',
    question: 'How does your design ensure equal access for all users?',
    answers: [
      'Ensures no misleading content or disinformation is included',
      'Presents relevant language choices/options',
      'Delivers information in as easy-to-understand language as possible',
      'Suggests alternate content delivery methods and/or user interactions (e.g., text-to-speech, braille, etc.)',
      'Provides enhanced readability/visibility options (e.g., adjustable fonts, brightness, color, etc.)',
      'Offers ethical pricing, lower-cost and/or payment-free options',
      'Not sure / Not applicable',
      'Other',
    ],
  },
  {
    fieldname: 'communicationEcoQuestion4',
    question:
      'Which design decisions were taken to prioritize environmental sustainability?',
    answers: [
      'Implement energy-efficient coding practices and website/digital optimization techniques',
      'Select energy- and waste-optimized inputs (e.g., music, fonts, images, lighting, etc.)',
      'Other',
      'Opt for remote collaboration vs. in-person travel whenever possible',
      'Integrate language and storytelling that raises awareness of sustainability and/or encourages other positive behaviours',
      'Not sure / Not applicable',
      'Host digital assets on servers powered by renewable energy sources (e.g., solar, wind, etc.)',
      'Consider streaming impact in design (e.g., resolution defaults, adaptive streaming, offline access, etc.)',
      'Design visuals/animations to minimise processing demand (e.g., fewer frames, simplified motion, SVG over video, etc.)',
      'Minimize data transfer and server load by optimizing file sizes and formats',
    ],
  },
  {
    fieldname: 'interriorArchitectureEcoQuestions1',
    question:
      'Which design decisions were made to prioritize lower energy consumption and reduced resource use during daily operations?',
    answers: [
      'Other',
      'Not sure / Not applicable',
      'Ongoing social and/or environmental measurement and monitoring',
      'Planned obsolescence incl. disassembly and material reuse and recycling',
      'Space-saving and multifunctional furniture',
      'Flexible and adaptable spaces that can be easily retrofitted or modified for future changes',
      'Renewable energy systems (e.g., solar panels, wind turbines, geothermal, etc.)',
      'Water-saving fixtures and systems (e.g., low-flow faucets, dual-flush toilets, etc.)',
      'Energy-efficient lighting systems (e.g., LED fixtures, automated sensors, etc.)',
      'Materials with low environmental impact (e.g., recycled, locally sourced, etc.)',
      'Passive design strategies (e.g., natural ventilation, daylighting, etc.)',
    ],
  },
  {
    fieldname: 'interriorArchitectureEcoQuestions2',
    question:
      'In what ways does your design support and promote human health and well-being from construction through end of life?',
    answers: [
      'Use of materials from fair labor sources',
      'Ensure healthy air circulation, filtration, and light',
      'Build personal wellness options into the design',
      'Flexible spaces for multi-use',
      'Prioritize construction worker safety (e.g., protective equipment, training, rest areas, etc.)',
      'Execute clear waste management strategies in construction (e.g., recycling, salvage, etc.)',
      'Other',
      'Use of low-embodied carbon materials',
      'Not sure / Not applicable',
      'Select furniture and fixtures that are easy to use and adjust',
      'Use of non-toxic materials (low VOC)',
      'Pay construction workers a livable wage',
      'Use of compostable materials',
      'Use materials with high recycled content',
    ],
  },
  {
    fieldname: 'interriorArchitectureEcoQuestions3',
    question: 'How do you ensure equal access for all users?',
    answers: [
      'Implement clear wayfinding',
      'Provide gender- and culturally-sensitive private areas',
      'Engage broad stakeholders and account for inclusion in any public or shared spaces',
      'Not sure / Not applicable',
      'Other',
      'Implement universal design principles',
      'Incorporate adaptive equipment and features, such as adjustable-height countertops',
      'Install proper lighting to enhance visibility and safety',
      'Use contrasting colors and textures to aid individuals with visual impairments',
      'Consider diverse sensory needs, such as noise levels and tactile experience',
      'Create clear pathways and circulation routes for wheelchair accessibility',
      'Select furniture and fixtures that are easy to use and adjustable',
    ],
  },
  {
    fieldname: 'packagingEcoQuestion1',
    question: 'What end of life scenario(s) best describes this design?',
    answers: [
      'Repurpose',
      '100% Recyclable',
      'Biodegradable',
      'Compostable',
      'Reusable / Refillable',
      'Landfill',
      'Other',
    ],
  },
  {
    fieldname: 'packagingEcoQuestion2',
    question:
      'Which material and/or design decisions were made to reduce the packaging’s environmental impact?',
    answers: [
      'Biobased materials',
      'Renewable materials',
      'Non-toxic ink',
      'Compacted footprint and/or other shipping efficiencies',
      'Biodegradable materials',
      'Recycled content materials',
      'Not sure / Not applicable',
      'Digital watermarking and/or other traceability technology',
      'Fiber-based materials',
      'Re-use elements from shipping to distribution/point of sale',
      'Lightweighting / Reduced overall packaging weight and/or packaging-to-product ratio',
      'Sustainably-forested materials',
      'Mono-materials that can be clearly separated at end of life',
      'None of the above',
      'Non-plastic / Non-fossil fuel based materials',
    ],
  },
  {
    fieldname: 'packagingEcoQuestion3',
    question:
      'How do you encourage appropriate end of life disposal (e.g., recycle, compost, landfill)?',
    answers: [
      'Second life / Extension innovations',
      'Other',
      'Not sure / Not applicable',
      'Third party partnerships for reuse/recycle/upcycle',
      'Return service incl. takeback and/or rewards program',
      'Clear material type and recycling labelling or markings',
      'Easily separable materials',
      'Mono-materials',
    ],
  },
  {
    fieldname: 'productEcoQuestion1',
    question:
      'What sustainable design strategies are incorporated into the design of this product?',
    answers: [
      'Resale - embed value-retaining strategies to enable secondary market engagement',
      'Reuse - repurpose components, materials, products, or processes',
      'Reduce - use less material and/or energy',
      'Rethink - avoid application of unnecessary or unsustainable elements/components',
      'Refuse- prevents unnecessary creation',
      'Explain',
      'Not sure / Not applicable',
      'Recycle - utilize post-industrial or post-consumer materials',
      'Remanufacture / Repurpose / Upcycle - integrate elements and component materials from previously used products',
      'Refurbish - provide opportunities for reuse and sales in secondary markets',
      'Upgrade - offer upgradable or replacement parts to ensure continued performance over time',
      'Repair - enable access to components or replacement parts to restore and extend functionality',
    ],
  },
  {
    fieldname: 'productEcoQuestion1a',
    question:
      'How is sustainability prioritized in the design of this vehicle?',
    answers: [
      'Other',
      'Not sure / Not applicable',
      'Enhanced end-of-use services (e.g. innovative take-back, repair, or donation programs)',
      'Emphasis on repairability and long service life',
      'Production processes powered by renewable energy',
      'Innovative use of upcycled/recycled material in its construction',
      'Higher percentage of recyclable materials used',
      'More efficient than a typical vehicle in its class',
      'Encourages driver to conserve energy or operate more efficiently',
      'Powered by renewable energy',
    ],
  },
  {
    fieldname: 'productEcoQuestion2',
    question:
      'How did you design this product to promote inclusivity, accessibility, and affordability for all users?',
    answers: [
      'Integrate features that cater to individuals with disabilities or special requirements',
      'Incorporate universal design principles',
      'Collaborate with special user groups and/or experts for feedback and insights',
      'Not sure / Not applicable',
      'Other',
    ],
  },
  {
    fieldname: 'productEcoQuestion2a',
    question:
      'How did you design this vehicle to promote inclusivity and accessibility for all users?',
    answers: [
      'Other',
      'Incorporate universal design principles',
      'Integrate features that cater to individuals with disabilities or special requirements',
      'Collaborate with special user groups and/or experts for feedback and insights',
      'Not sure / Not applicable',
    ],
  },
  {
    fieldname: 'productEcoQuestion3',
    question:
      'Which design decisions did you take to encourage more sustainable user behavior?',
    answers: [
      "Provide educational materials such as user manuals or online resources that explain the product's lifecycle and carbon footprint",
      'Integrate feedback mechanisms into the product that inform users of their resource consumption',
      'Offer end-of-use services (e.g. take-back, repair, donation, etc.)',
      'Not sure / Not applicable',
      'Other',
      'Set all default operating standards to the most sustainable performance',
      'Incorporate informative labeling that highlights the product’s environmental impact',
      'Create interactive user interfaces or apps that provide sustainably-minded tips and guidance',
    ],
  },
  {
    fieldname: 'productEcoQuestion3a',
    question:
      'Which design decisions did you take to encourage more sustainable user behavior?',
    answers: [
      'Create interactive user interfaces or apps that highlight the vehicle’s environmental impact and opportunities for improvement',
      'Not sure / Not applicable',
      "Provide educational materials such as user manuals or online resources that explain the product's lifecycle and environmental impact",
      'Integrate feedback mechanisms into the vehicle that inform drivers to conserve energy/power during operation',
      'Incorporate visual design cues that communicate the vehicle’s commitment to sustainability',
      'Set default operating standards to the most environmentally-sensitive performance',
      'Other',
      'Provide instructions for eco-friendly use and disposal (including parts)',
    ],
  },
  {
    fieldname: 'serviceDesignEcoQuestion1',
    question:
      'Which design decisions were taken to prioritize environmental sustainability?',
    answers: [
      'Provide reusable or refillable packaging',
      'Commit to ongoing social and/or environmental measurement and monitoring',
      'Not sure / Not applicable',
      'Other',
      'Offer low-carbon emissions / material footprint options',
      'Source reused or upcycled components',
      'Source relevant material streams from regenerative suppliers',
      'Use 100% recycled materials whenever possible',
      'Use greenest available materials and techniques for any physical asset production',
      'Incorporate digital solutions to reduce/remove physical/paper outputs whenever possible',
      'Evaluate carbon emissions generated across the user journey',
      'Support biodiversity initiatives in relevant local communities (e.g., food waste composting, pollinator protections, etc.)',
      'Prioritize use of energy-efficient technologies (e.g., cloud-based)',
      'Reduce energy usage and/or utilize renewable sources (e.g., solar, wind, etc.)',
    ],
  },
  {
    fieldname: 'serviceDesignEcoQuestion2',
    question:
      'How have you designed your service’s various touchpoints to promote inclusivity, accessibility, and affordability for all users?',
    answers: [
      'Train staff and provide superior customer support (e.g., 24/7, human-powered, etc.)',
      'Represent diversity in marketing materials and team hiring',
      'Include stakeholders of diverse backgrounds in the design process (e.g., focus groups, creative talent, etc.)',
      'Offer ethical pricing including relevant discounts and rewards',
      'Account for local community inclusion and partnership',
      'Not sure / Not applicable',
      'Other',
      'Provide options for hearing-impaired users (e.g., volume controls, text-to-speech, etc.)',
      'Provide options for mobility-challenged users',
      'Provide options for visually-impaired users  (e.g., braille, adjustable fonts, brightness, color, etc.)',
      'Present Information as clearly as possible',
      'Use inclusive language',
      'Present different language choices/options',
      'Provide educational resources for user learning and development',
      'Provide personalized service options to meet individual preferences, including cultural needs',
    ],
  },
  {
    fieldname: 'serviceDesignEcoQuestion3',
    question:
      'In what ways does your service support and promote human and societal well-being?',
    answers: [
      'Prioritize local hiring',
      'Focus procurement practices on small businesses and local economies',
      'Support community initiatives (e.g., education, healthcare, volunteering, etc.)',
      'Support disadvantaged and/or marginalized communities (e.g., homeless, refugees, disabled, etc.)',
      'Partner with NGOs or similar experts to support social and/or environmental causes',
      'Create virtuous cycle / positive feedback loops within our user and supplier communities',
      'Not sure / Not applicable',
      'Other',
      'Provide training and development opportunities to team members',
      'Pay a living wage and provide a safe working environment',
      'Promote employee health and work-life balance',
    ],
  },
  {
    fieldname: 'uiDesignEcoQuestion1',
    question:
      'Which design decisions were taken to prioritize environmental sustainability?',
    answers: [
      'Set default operating standards to the most environmentally sensitive performance',
      'Guide users toward lower footprint choices',
      'Power digital services with renewable energy (e.g., solar, wind, etc.)',
      'Indicate the user’s overall footprint and contribution',
      'Create user flows that reduce energy consumption',
      'Select energy-optimized fonts, imagery and video (e.g., compression, modern formats, etc.)',
      'Reduce load times to reduce energy consumption',
      'Other',
      'Not sure / Not applicable',
      'Ongoing measurement and monitoring for optimization',
    ],
  },
  {
    fieldname: 'uxDesignEcoQuestion1',
    question:
      'Which design decisions were taken to prioritize environmental sustainability?',
    answers: [
      'Indicate the user’s overall footprint and contribution',
      'Create user flows that reduce energy consumption',
      'Power digital services with renewable energy (e.g., solar, wind, etc.)',
      'Reduce/Remove physical outputs whenever possible for a lower energy and material footprint',
      'Indicate material choices and educate on the reason why',
      'Use greenest materials and techniques available for any physical asset production',
      'Not sure / Not applicable',
      'Raise awareness for environmental issues',
      'Ongoing measurement and monitoring for optimization',
      'Prioritize modular or updateable design over replaceable products or interfaces',
      'Reduce load times to reduce energy consumption',
      'Other',
      'Set default operating standards to the most environmentally sensitive performance',
      'Guide users toward lower energy/materials footprint choice',
    ],
  },
];

export function getEcoQuestionFieldNames() {
  return ECO_QUESTIONS.map((question) => question.fieldname);
}
